<div class="master-data-dashboard">
  <h2 class="m-b-24">Master Data</h2>
  <div class="dashboard-grid">
    @for (card of dashboardCards; track card) {
      <div class="dashboard-card" [routerLink]="card.route" style="cursor: pointer">
        <div class="dashboard-card-header">
          <span class="dashboard-card-title">{{ card.title }}</span>
          <span class="dashboard-card-arrow">&#8594;</span>
        </div>
        <div class="dashboard-card-desc">{{ card.description }}</div>
      </div>
    }
  </div>

  <!-- Show message when no cards are visible -->
  @if (dashboardCards.length === 0) {
    <div class="no-access-message">
      <p>You do not have access to any Master Data modules.</p>
    </div>
  }
</div>
